import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { ReactiveFormsModule } from '@angular/forms';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { SofboxModule } from './../sofbox/sofbox.module';
import { CountToModule } from 'angular-count-to';
import { IndexComponent } from './index/index.component';
import { HomeComponent } from './components/home/home.component';
import { ActivateComponent } from './components/activate/activate.component';
import { ClaimComponent } from './components/claim/claim.component';
import { PaymentComponent } from './components/payment/payment.component';
import { CoBrandingComponent } from './components/co-branding/co-branding.component';
import { PasswordStrengthComponent } from '../password-strength/password-strength.component';
import { SSOComponent } from './components/sso/sso.component';

import '../../assets/js/custom';

// Import your library
import { OwlModule } from 'ngx-owl-carousel';

const routes: Routes = [
  {
    path: 'members/:clientid',
    component: IndexComponent
  },
  {
    path: 'members/:clientid/payment',
    component: PaymentComponent
  },
  {
    path: 'members/:clientid/activate/:memberid',
    component: ActivateComponent
  },
  {
    path: 'members/:clientid/claim',
    component: ClaimComponent
  },
  {
    path: 'members/:clientid/sso',
    component: SSOComponent
  },
  {
    path: 'co-branding',
    component: CoBrandingComponent
  }
];

@NgModule({
  declarations: [
    IndexComponent,
    HomeComponent,
    ActivateComponent,
    ClaimComponent,
    SSOComponent,
    PaymentComponent,
    CoBrandingComponent,
    PasswordStrengthComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgZorroAntdModule,
    Ng4LoadingSpinnerModule.forRoot(),
    RouterModule.forChild(routes),
    SofboxModule,
    CountToModule,
    OwlModule
  ]
})
export class LandingPageModule { }
